import API from "api/base/base";
import { appendQueryArgs } from "utils/apiHelpers";
import { axios } from "utils/axios";

const Groups = new API({ controller: "groups" });

Object.assign(Groups, {
  colors() {
    return axios.get(appendQueryArgs(`${this.url}/calendar_colors`));
  },
  updateCategories(id, payload) {
    return axios.post(`${this.url}/${id}/update_categories`, payload);
  },
});

export default Groups;
